module.exports = __webpack_public_path__ + "media/images/category/feature/index/logo-index-coj-4b91a21f9fb93bcb508a3da0f3018e7f.svg";